<template>
    <div>
        <div class="opui-row">
            <div class="opui-col">
                <label class="opui-form-label-top">{{ $e('Webhook URL') }}</label>
                <input type="url" placeholder="https://" class="opui-form-control" v-model="item.settings.url" @input="updateDescription" required>
            </div>
        </div>

        <div class="opui-row">
            <div class="opui-col">
                <label class="opui-form-label-top">{{ $e('Request Type') }}</label>
                <select class="opui-form-control" v-model="item.settings.request_type" @change="updateDescription">
                    <option value="post">POST</option>
                    <option value="get">GET</option>
                </select>
            </div>
        </div>

        <FieldMap :workflow="workflow" :item="item" />
    </div>
</template>

<script>
import FieldMap from "./FieldMap.vue"
export default {
    components: { FieldMap },
    props: {
        workflow: { type: Object, required: true },
        item:     { type: Object, required: true },
    },
    mounted() {
        // Set default request type
        if (! this.item.settings.request_type) {
            this.item.settings.request_type = 'post'
        }

        this.validate()
    },
    methods: {
        updateDescription() {
            this.item.description = this.item.settings.request_type.toUpperCase() + ": " + this.item.settings.url
            this.validate()
        },

        validate() {
            if (this.item.settings.request_type && this.item.settings.url) {
                this.item.validated = true
            } else {
                this.item.validated = false
            }
        }
    }
}
</script>
